import React from "react";
import DocumentViewer from "./DocumentViewer";
import pdf from "assets/documents/pdfs/baa.pdf";

const Baa = () => <DocumentViewer pdf={pdf} />;

export default Baa;
